import { Injectable } from '@angular/core';

import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  languageChange$: Observable<LangChangeEvent> = this.translateService.onLangChange;

  constructor(private translateService: TranslateService) {}

  getSelectedLanguage(): string {
    return this.translateService.currentLang;
  }

  setDefaultLanguage(defaultLanguage: string): void {
    this.translateService.setDefaultLang(defaultLanguage);
    this.setSelectedLanguage(defaultLanguage);
  }

  setSelectedLanguage(language: string): void {
    this.translateService.use(language);
  }
}
